import React, { useEffect } from 'react';
import { TableRow } from '@material-ui/core';
import { LoaderRow, Table } from '../../../../../ui-kit';
import { useDebounce } from '../../../../../utils';
import { useUser } from '../../../../../utils/hooks/auth';
import { useProductQueryContext } from '../../hooks';
import { Row, TablePaginationWithCount, TableProps } from './types';
import { getProductTableHeadCells, mapProductsToRows } from './utils';
import ProductTableCell from './ProductTableCell';
import ProductTableHeadCell from './ProductTableHeadCell';

const ProductTableView = ({ data, pagination, isLoading }: TableProps) => {
    const [lastCount, setLastCount] = React.useState(0);
    const { user: { venueType } } = useUser();

    const {
        query, setQuery,
        rowsPerPage,
        setPage,
        markupSort, setMarkupSort,
        foodCostSort, setFoodCostSort,
    } = useProductQueryContext();

    const debouncedName = useDebounce(query);
    useEffect(() => {
        setQuery(debouncedName);
        setPage(0);
    }, [debouncedName, setQuery, setPage]);

    useEffect(() => {
        if(data){
            const { paginatedProducts: { count } } = data;
            setLastCount(count);
        }
    }, [data]);

    let tableContent = null;

    const headCells = getProductTableHeadCells(venueType);

    if(isLoading){
        tableContent = <LoaderRow itemsPerPage={rowsPerPage} columnCount={headCells.length} itemHeight={53} />;
    }


    if(data){
        const { paginatedProducts: { items } } = data;
        const rows = mapProductsToRows(items);

        tableContent = rows.map(row => (
            <TableRow tabIndex={-1} key={row.id}>
                {headCells.map(({ id, align }) => <ProductTableCell key={id} id={id} align={align} row={row} />)}
            </TableRow>
        ));
    }

    const tablePagination: TablePaginationWithCount = { count: lastCount, ...pagination };
    const handleSetFoodCostSort = (newSort: string | false) => {
        if(markupSort){
            setMarkupSort(false);
        }
        setFoodCostSort(newSort);
    };

    const handleSetMarkupSort = (newSort: string | false) => {
        if(foodCostSort){
            setFoodCostSort(false);
        }
        setMarkupSort(newSort);
    };

    return (
        <Table<Row>
            headCells={headCells}
            TableHeadCellComponent={ProductTableHeadCell}
            customHeadCellProps={{
                query, setQuery,
                markupSort, setMarkupSort: handleSetMarkupSort,
                foodCostSort, setFoodCostSort: handleSetFoodCostSort,
            }}
            tablePagination={tablePagination}
        >
            {tableContent}
        </Table>
    );
};

export default ProductTableView;
